<form
  [dir]="rtlEnabled ? 'rtl' : 'auto'"
  id="MFAform"
  method="POST"
  (ngSubmit)="confirmSecondFactor()()"
  [formGroup]="Form()"
>
  @if (viewState().showSecondFactor && res) {
    <div class="MFA-form" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px">
      @if (viewState().secondFactor.setup) {
        <div class="information-msg information-title">
          <p>{{ res().get('SecondFactor-SetupTitle') }}</p>
        </div>
      }
      @if (viewState().secondFactor.setup) {
        <div class="information-msg information-description">
          <p>
            <strong>{{ res().get('SecondFactor-Step1') }}</strong
            >{{ res().get('SecondFactor-SetupDescription1') }}
          </p>
          <p>
            <strong>{{ res().get('SecondFactor-Step2') }}</strong
            >{{ res().get('SecondFactor-SetupDescription2') }}
          </p>
        </div>
      }
      @if (viewState().secondFactor.setupDeprecated) {
        <div class="information-msg">
          {{ res().get('SecondFactor-SetupDeprecatedTitle') }}
        </div>
      }
      @if (viewState().secondFactor.input) {
        <div class="information-msg information-title">
          <p>{{ res().get('SecondFactor-InputTitle') }}</p>
        </div>
      }
      @if (viewState().secondFactor.input) {
        <div class="information-msg">
          {{ res().get('SecondFactor-InputDescription') }}
        </div>
      }
      @if (viewState().secondFactor.invalidConfig) {
        <div class="information-msg">
          {{ res().get('SecondFactor-InvalidConfig') }}
        </div>
      }
      @if (viewState().secondFactor.invalidConfig) {
        <button class="button button-invalid" style="width: 65%" (click)="cancelSecondFactor()">
          {{ res().get('Cancel') }}
        </button>
      }
      @if (viewState().secondFactor.showInvalidCodeMessage) {
        <div class="msgError">
          {{ res().get('SecondFactor-InvalidCode') }}
        </div>
      }
      <div
        class="setupTwoFactor"
        [ngClass]="{ qrCodePosition: viewState().secondFactor.showInput }"
        fxLayoutAlign="space-around center"
        fxLayoutGap="20px"
        fxLayout="column"
      >
        @if (viewState().secondFactor.shouldSetup) {
          <div class="optinalTwoFactorButtons" fxLayout="column" fxLayoutAlign="space-around center" fxLayoutGap="30px">
            <span class="msg-notification"> {{ res().get('SecondFactor-ShouldSetup') }}</span>
            <div fxLayout="column" fxLayoutGap="20px" style="width: 100%">
              <button class="button button-first" (click)="setOptionalSecondFactor()()" type="button">
                {{ res().get('Login-Setup-MFA') }}
              </button>
              <button class="button button-second" (click)="confirmSecondFactor()()" type="button">
                {{ res().get('Login-Skip-MFA') }}
              </button>
            </div>
          </div>
        }
        @if (viewState().secondFactor.showQRCode) {
          <div class="qrCodeContainer" fxLayout="column">
            <abc-qrcode-viewer
              [width]="'100px'"
              [height]="'100px'"
              [color]="'var(--PrimaryMainColor)'"
              [qrData]="baseUrl() + '/QR/' + secret() + '?otpauth=totp&user=' + username() + '&issuer=' + issuer()"
            ></abc-qrcode-viewer>
            <p>{{ res().get('SecondFactor-SecretInfo') }}</p>
            <p>{{ secret() }}</p>
          </div>
        }
        @if (viewState().secondFactor.showInput) {
          <div class="twoFactorCode" fxLayout="column" fxLayoutGap="20px">
            <div
              class="input-qrCode"
              [ngStyle]="viewState().secondFactor.showQRCode ? { color: 'black' } : { color: 'white' }"
              fxLayout="row"
              fxLayoutAlign="space-between center"
              fxLayoutGap="10px"
            >
              @for (holder of placeholders(); track $index; let i = $index) {
                <div>
                  <input
                    #input
                    id="input"
                    class="two-fa-input"
                    (click)="onClick()($event)"
                    (paste)="onPaste()($event, i)"
                    (input)="onInput()($event, i)"
                    (keydown)="onKeydown()($event, i)"
                    [type]="inputType() || 'text'"
                    [disabled]="false"
                    [attr.inputmode]="inputMode() || 'numeric'"
                    [attr.autocapitalize]="true"
                    autocomplete="one-time-code"
                    maxlength="1"
                  />
                </div>
              }
            </div>
            <button
              [type]="'submit'"
              #submitButton
              id="confirmMFACode"
              class="button confirmButton"
              (click)="confirmSecondFactor()()"
              [ngStyle]="{ opacity: !confirmationcodeFilled() ? '0.5' : '1' }"
              [disabled]="!confirmationcodeFilled()"
            >
              {{ res().get('Login-Login') }}
            </button>
            <button
              [type]="'button'"
              class="button cancelButton"
              (click)="cancelSecondFactor()()"
              [disabled]="viewState().secondFactor.setupDeprecated"
            >
              {{ res().get('Cancel') }}
            </button>
          </div>
        }
      </div>
    </div>
  }

  @if (viewState().showChangePassword) {
    <div class="information-msg">
      {{ res().get('Login-NeedsPasswordChangeTitle') }}
    </div>
  }
</form>
